import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MensajesService {

  constructor() { }

  private mensajero: BehaviorSubject<any> = new BehaviorSubject({
    filtroByWord: '',
    filtroByHam: '',
    tipoFiltro: 0
  });

  // Método público para quien se quiera suscribir a los mensajes
  public escucha(): Observable<any> {
      return this.mensajero.asObservable();
  }
  
  // Método público para quien quiera emitir un mensaje
  public emite(msj: any): void {
      this.mensajero.next(msj);
  }
}
